/* Meal details popup — shared modal, one per section.
   Mirrors the plan builder (assets/section-plan-builder.js openInfoModal/closeInfoModal):
   each card carries an inert <template data-pb-info-template> holding its own body,
   which is cloned into the single modal on open. <template> content is not live DOM,
   so a carousel of 50 cards costs markup bytes but no images, nodes or layout.

   Expected markup inside the scope element:
   - trigger:  <button data-pb-info>            (inside a [data-pb-card])
   - body src: <template data-pb-info-template> (inside the same [data-pb-card])
   - modal:    {% render 'plan-builder-info-modal' %} wrapped in <meal-info-modal> */

if (!customElements.get("meal-info-modal")) {
  customElements.define(
    "meal-info-modal",
    class MealInfoModal extends HTMLElement {
      connectedCallback() {
        this.modal = this.querySelector("[data-pb-info-modal]");
        this.body = this.querySelector("[data-pb-info-body]");
        // Delegate on the section so triggers work for cards Flickity clones or
        // moves between panels. Falls back to this element's parent.
        this.scope = this.closest("[data-meal-info-scope]") || this.parentElement;

        this._onClick = this._onClick.bind(this);
        this._onKeydown = this._onKeydown.bind(this);
        this.scope?.addEventListener("click", this._onClick);
        document.addEventListener("keydown", this._onKeydown);
      }

      disconnectedCallback() {
        this.scope?.removeEventListener("click", this._onClick);
        document.removeEventListener("keydown", this._onKeydown);
      }

      _onClick(event) {
        const trigger = event.target.closest("[data-pb-info]");
        if (trigger) {
          event.preventDefault();
          this.open(trigger);
          return;
        }
        if (event.target.closest("[data-pb-info-close]")) {
          event.preventDefault();
          this.close();
        }
      }

      _onKeydown(event) {
        if (event.key === "Escape") this.close();
      }

      open(trigger) {
        const card = trigger.closest("[data-pb-card]");
        const tpl = card?.querySelector("[data-pb-info-template]");
        if (!this.modal || !this.body || !tpl) return;

        this._lastTrigger = trigger;
        this.body.innerHTML = "";
        this.body.appendChild(tpl.content.cloneNode(true));
        this.modal.removeAttribute("hidden");
        document.body.style.overflow = "hidden";
        this.modal.querySelector("[data-pb-info-close]")?.focus();
      }

      close() {
        if (!this.modal || this.modal.hasAttribute("hidden")) return;
        this.modal.setAttribute("hidden", "");
        if (this.body) this.body.innerHTML = "";
        document.body.style.overflow = "";
        this._lastTrigger?.focus();
        this._lastTrigger = null;
      }
    },
  );
}
